import type { Prototype } from "../prototype-types";

export const nakulPathakPrototypes: Prototype[] = [
  {
    id: "np-stores-like-yours",
    name: "Stores Like Yours",
    path: "/np/stores-like-yours",
    description: "Prototype for show-casing what we can do for stores like yours with a private approach",
    owner: "Nakul Pathak",
    createdAt: "2026-09-24",
    lastUpdated: "2026-09-24",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    creationTool: "claude-code",
    thumbnail: "/images/thumbnails/np-stores-like-yours.png",
    project: "Stores like yours prototype",
    figmaLink:
      "https://www.figma.com/design/jPUSKT6dOYM572rWY1XWQu/Inspire-Big-Bets--26?node-id=546-36317&t=uuTBDo47pAzkKG48-0",
  },
];
